import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import "./auth.css";  // <-- add stylesheet

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('https://airdrop-api-pe6y.onrender.com/api/login/', {
        username,
        password
      });

      localStorage.setItem('access_token', res.data.tokens.access);
      localStorage.setItem('refresh_token', res.data.tokens.refresh);
      localStorage.setItem('username', res.data.username);

      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2 className="auth-title">Welcome Back</h2>
        <p className="auth-subtitle">Log in to continue</p>

        <form onSubmit={handleLogin} className="auth-form">

          <input 
            className="auth-input"
            placeholder="Username"
            value={username}
            onChange={e => setUsername(e.target.value)}
          />

          <input 
            className="auth-input"
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />

          <button type="submit" className="auth-btn">Login</button>
        </form>

        {error && <p className="auth-error">{error}</p>}

        <p className="auth-footer">
          Don't have an account? <Link className="auth-link" to="/register">Register here</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;
